<template>
	<div class="brick">
		<div class="view_inner">
			<div class="list_top_box">
				<!--				<div class="left_option"></div>-->
			</div>

			<div class="half_tbl_box">
				<user-defined-group-list @click="listClickEvent" />

				<div class="right_big_tbl">
					<UserDefinedGroupItemClassList @input="selectClass" />
					<UserDefinedGroupClass v-model="ud.ud_no" ref="userDefinedGroupClass" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import UserDefinedGroupList from '@/views/item/UserDefinedGroup/UserDefinedGroupList';
import UserDefinedGroupItemClassList from '@/views/item/UserDefinedGroup/UserDefinedGroupItemClassList';
import UserDefinedGroupClass from '@/views/item/UserDefinedGroup/UserDefinedGroupClass';

export default {
	name: 'UserDefinedGroup',
	components: {
		UserDefinedGroupItemClassList,
		UserDefinedGroupClass,
		UserDefinedGroupList,
	},
	data: function() {
		return {
			ud: {
				ud_no: 0,
			},
		};
	},
	methods: {
		listClickEvent(ud_no) {
			this.ud.ud_no = ud_no;
		},
		selectClass(code) {
			if (this.ud.ud_no) {
				this.$refs.userDefinedGroupClass.setClass(code);
			} else {
				this.$toast.error('Not Select User Defined Group');
			}
		},
	},

	mounted() {
		this.$store.commit('setSideIndex', 1);
		this.$store.commit('setSelectedMenu', 'nav_li_user_defined_group');
		this.$store.commit('setSubTitle', 'Item -> User Defined Group');
	},
};
</script>
